import { getCleanFileName } from './files';
import { notLettersOrNumbersWithExtraChars } from 'Regex';
import { IAlternativeMedicineFormData } from 'Modules/Reimbursements/AlternativeMedicine/AlternativeMedicineMain';
import { ICannabisFormData } from 'Modules/Reimbursements/Cannabis/CannabisMain';
import { NavigateFunction } from 'react-router-dom';
import { IAlternativeMedicineContext } from 'Context/AlternativeMedicine';

export const reimbursementsFormPrepareAlternativeMedicineFormData = (
  requestsData: IAlternativeMedicineFormData,
  getTreatmentTypeCode: (name: string) => number | undefined
) => {
  // Build form data object before submit
  const formData = new FormData();
  formData.append('note', requestsData.additionalDetails || '');
  formData.append('phoneNumber', requestsData.phone.number || '');
  formData.append('phonePrefixId', requestsData.phone.prefix?.toString() || '');
  formData.append('shikumSubTypeId', requestsData.type.toString());

  requestsData.invoices.forEach((field, index) => {
    if (!field.file) return;

    formData.append(
      `fieldAttachmentsData[${index}].fieldId`,
      requestsData.fieldId
    );
    const renamedFile = new File(
      [field.file],
      getCleanFileName(field.file.name),
      {
        type: field.file.type,
      }
    );
    formData.append(`fieldAttachmentsData[${index}].attachments`, renamedFile);
    const invoicesJson = {
      isApproved: requestsData.isApproved,
      invoicesDetails: requestsData.invoices.map((invoice) => {
        const treatmentTypeCode = getTreatmentTypeCode(
          invoice.treatmentTypeName || ''
        );
        return {
          invoiceNumber: invoice.invoiceId,
          invoiceDate: invoice.invoiceDate,
          invoiceAmount: invoice.invoiceTotal,
          vendorName: invoice.vendorName,
          treatmentsTypeCode: treatmentTypeCode,
          treatmentTypeOther: treatmentTypeCode
            ? undefined
            : requestsData.treatmentType,
        };
      }),
    };
    formData.append('requestDataJson', JSON.stringify(invoicesJson));
  });

  return formData;
};

export const reimbursementsFormPrepareCannabisFormData = (
  requestsData: ICannabisFormData
) => {
  // Build form data object before submit
  const formData = new FormData();
  formData.append('note', requestsData.additionalDetails || '');
  formData.append('phoneNumber', requestsData.phone.number || '');
  formData.append('phonePrefixId', requestsData.phone.prefix?.toString() || '');
  formData.append('shikumSubTypeId', requestsData.type.toString());

  requestsData.invoices.forEach((field, index) => {
    if (!field.file) return;

    formData.append(
      `fieldAttachmentsData[${index}].fieldId`,
      requestsData.fieldId
    );
    const renamedFile = new File(
      [field.file],
      getCleanFileName(field.file.name),
      {
        type: field.file.type,
      }
    );
    formData.append(`fieldAttachmentsData[${index}].attachments`, renamedFile);
    const invoicesJson = {
      isApproved: requestsData.isApproved,
      invoicesDetails: requestsData.invoices.map((invoice) => ({
        invoiceNumber: invoice.invoiceId,
        invoiceDate: invoice.invoiceDate,
        invoiceAmount: invoice.invoiceTotal,
      })),
    };
    formData.append('requestDataJson', JSON.stringify(invoicesJson));
  });

  return formData;
};

export const filterAndLimitInput = (
  e: React.ChangeEvent<HTMLInputElement>,
  maxInvoiceLength: number
) => {
  const value = e.target.value;
  const filteredValue = value
    .replace(notLettersOrNumbersWithExtraChars, '')
    .slice(0, maxInvoiceLength);
  e.target.value = filteredValue;
  return filteredValue;
};

interface IHandleBackParams {
  isExitBtn?: boolean;
  navigate: NavigateFunction;
  context: IAlternativeMedicineContext;
}

export const handleBackNavigation = ({
  navigate,
  isExitBtn,
  context,
}: IHandleBackParams): void => {
  const {
    handlePrevStep,
    currentStep,
    showTreatmentTypeForm,
    setShowTreatmentTypeForm,
    formData,
    onClickReturnToMain,
    setShowUploadFileArea,
  } = context;

  if (
    currentStep === 1 &&
    !formData.invoices.length &&
    !formData.treatmentType
  ) {
    navigate('/reimbursements');
    return;
  }

  if (
    currentStep === 1 &&
    !formData.invoices.length &&
    formData.treatmentType
  ) {
    setShowTreatmentTypeForm(true);
    return;
  }

  if (currentStep === 1 && formData.invoices.length > 0 && isExitBtn) {
    onClickReturnToMain();
    return;
  }

  if (currentStep === 1) {
    if (formData.invoices.length > 0 && showTreatmentTypeForm) {
      setShowTreatmentTypeForm(false);
      setShowUploadFileArea(false);
    } else if (formData.invoices.length > 0) {
      setShowTreatmentTypeForm(true);
    }
    return;
  }

  if (currentStep > 1) {
    handlePrevStep();
    return;
  }

  navigate('/reimbursements');
};
